export default __webpack_public_path__ + "static/gunship-81bd4e8730651f4dae17d2b2f0d01a69.png";